import { Component, OnInit } from '@angular/core';
declare var $;

@Component({
  selector: 'app-reporte-resumen-de-obra-retornos-modal',
  templateUrl: './reporte-resumen-de-obra-retornos-modal.component.html',
  styleUrls: ['./reporte-resumen-de-obra-retornos-modal.component.scss']
})
export class ReporteResumenDeObraRetornosModalComponent implements OnInit {

  modalTitle: string = "";
  grupos: any[] = [];
  obra: any = {};
  constructor() { }

  ngOnInit() {
  }


  close(){
    $('#reporte-resumen-de-obra-retornos-modal').modal('hide');
  }

  open(data) {
    this.fill(data);
    $('#reporte-resumen-de-obra-retornos-modal').modal('show');
  }

  fill(data) {
    console.log('data modal ', data);
    this.modalTitle = data.modalTitle;
    this.grupos = data.grupos;
    this.obra = data.obra;
  }

  sumaTotalImporte(){
    var importe_total=0;
    for(var i=0;i<this.grupos[0].movimientos.length;i++){
      var movimiento = this.grupos[0].movimientos[i];
      importe_total += movimiento.importe;
    }
    return importe_total;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/reporte-resumen-de-obra/reporte-resumen-de-obra-retornos-modal/reporte-resumen-de-obra-retornos-modal.component.ts